import Bitmap = createjs.Bitmap;
/**
 * container for converted bitmaps, acts like a timeline
 */
export class FrameStrip {
    /** cache for all frames (like timeline in a MovieClip). */
    private _frames: Bitmap[] = [];

    /** attaches a frame to the timeline */
    public addFrame(frame: Bitmap): void {
        this._frames.push(frame);
    }

    /** returns the given frame */
    public getFrame(frameNumber: number): Bitmap {
        if (frameNumber >= 0 && frameNumber < this._frames.length) {
            return this._frames[frameNumber];
        }
        return null;
    }

    public setFrame(index: number, frame: Bitmap): void {
        if (index < this._frames.length) {
            this._frames[index] = frame;
        }
    }

    /** amount of frames in the timeline */
    public get frameAmount(): number {
        return this._frames.length;
    }

    /** is there more than one frame in the timeline */
    public get hasMultipleFrames(): boolean {
        return this._frames.length > 1;
    }

    /**
     *
     * removes an specific amount of frames from the end of strip
     *
     * @param count amount of frames to remove
     *
     */
    public removeLastFrames(count: number): void {
        if (this._frames.length >= count) {
            for (let i: number = 0; i < count; i++) {
                this._frames.pop();
            }
        }
    }

    public destroy(): void {
        // for (let flattenImage of this._frames) {
        //     if(flattenImage.image instanceof HTMLCanvasElement){
        //         flattenImage.image.width = flattenImage.image.height = 0;
        //     }
        // }

        // can be simplified because they use same canvas 
        if(this._frames.length > 0) {
            let frame = this._frames[0];
            if(frame.image instanceof HTMLCanvasElement) {
                frame.image.width = frame.image.height = 0;
            }
        }
        this._frames = [];
    }
}
